// extracted by mini-css-extract-plugin
module.exports = {"logoHeightSmall":"100px","logoHeightMedium":"150px","logoHeightLarge":"200px","blocked":"sxVariablesExported_blocked__KvXqf"};